import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "kyt-empty-state" }
const _hoisted_2 = { class: "empty-state-content" }
const _hoisted_3 = { class: "empty-state-icon mb-3" }
const _hoisted_4 = { class: "empty-state-title" }
const _hoisted_5 = {
  key: 0,
  class: "empty-state-description text-muted"
}
const _hoisted_6 = {
  key: 1,
  class: "empty-state-action mt-3"
}
const _hoisted_7 = {
  key: 2,
  class: "empty-state-custom mt-3"
}


import { computed } from 'vue';

const __default__ = {
    name: 'KytChainEmptyState'
};

interface Props {
    icon?: string;
    iconSize?: string | number;
    iconColor?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark' | 'muted';
    title: string;
    description?: string;
    showButton?: boolean;
    buttonText?: string;
    buttonIcon?: string;
    buttonVariant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark' | 'outline-primary' | 'outline-secondary';
}

interface Emits {
    (e: 'button-click'): void;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    icon: { default: 'search' },
    iconSize: { default: 48 },
    iconColor: { default: 'muted' },
    title: {},
    description: {},
    showButton: { type: Boolean, default: false },
    buttonText: {},
    buttonIcon: {},
    buttonVariant: { default: 'primary' }
  },
  emits: ["button-click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const buttonClass = computed(() => {
    return `btn-${props.buttonVariant}`;
});

const handleButtonClick = () => {
    emit('button-click');
};

return (_ctx: any,_cache: any) => {
  const _component_vue_feather = _resolveComponent("vue-feather")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_vue_feather, {
          type: __props.icon,
          size: __props.iconSize,
          class: _normalizeClass(`text-${__props.iconColor}`)
        }, null, 8, ["type", "size", "class"])
      ]),
      _createElementVNode("h5", _hoisted_4, _toDisplayString(__props.title), 1),
      (__props.description)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.description), 1))
        : _createCommentVNode("", true),
      (__props.showButton && __props.buttonText)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("button", {
              onClick: handleButtonClick,
              class: _normalizeClass(["btn", buttonClass.value])
            }, [
              (__props.buttonIcon)
                ? (_openBlock(), _createBlock(_component_vue_feather, {
                    key: 0,
                    type: __props.buttonIcon,
                    class: "me-1",
                    size: "16"
                  }, null, 8, ["type"]))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(__props.buttonText), 1)
            ], 2)
          ]))
        : _createCommentVNode("", true),
      (_ctx.$slots.default)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _renderSlot(_ctx.$slots, "default")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})